














































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { Prop, Watch } from 'vue-property-decorator'

import { Point } from '@/utils/types.ts'

import Categories from '@/store/current/categories.ts'
import Points from '@/store/current/points.ts'
import PointsMetrics from '@/store/current/pointsMetrics.ts'
import PointsSelection from '@/store/current/pointsSelection.ts'

const categories = getModule(Categories)
const points = getModule(Points)
const pointsMetrics = getModule(PointsMetrics)
const pointsSelection = getModule(PointsSelection)

@Component
export default class PointsList extends Vue {
  // computed
  get pointsArray (): Point[] {
    return points.asArray
  }
  get pointsIdxSelectionArray (): number[] {
    // v-list-item-group only allows to manage indexes of an array. We have to
    // transform the uuid to integers
    // https://vuetifyjs.com/en/components/list-item-groups
    const pointsSelectionSet = pointsSelection.asSet
    const arr: number[] = []
    // we have to loop on this.pointsArray to get the same indexes as in the
    // v-list-item element in the template
    // TODO: improve this?
    this.pointsArray.forEach((p, idx) => {
      if (pointsSelectionSet.has(p.id)) {
        arr.push(idx)
      }
    })
    return arr
  }
  set pointsIdxSelectionArray (idxArray: number[]) {
    // transform the index array back to a uuid array
    pointsSelection.fromArray(idxArray.map(idx => this.pointsArray[idx].id))
  }
  // Methods
  getArea (id: string): number {
    const area = pointsMetrics.getArea(id)
    return area ? 100 * area.area : 0
  }
  getAreaString (id: string): string {
    const area = pointsMetrics.getArea(id)
    return area ? `Area: ${Math.round(100 * area.area)}%` : ``
  }
  getColor (id: string): string {
    return categories.getColor(id)
  }
}
